import {classNames, layout, PushButton, theme, View, ViewContent} from "@variocube/cube-ui";
import * as React from "react";
import {useCallback} from "react";
import {stylesheet} from "typestyle";
import {Product} from "../types";
import {Inventory} from "../inventory";
import {VendingViewHeader} from "../header";
import {useLocalization} from "../../i18n";

export interface AdminProductViewProps {
    product: Product;
    inventory: Inventory;
    onStore: (product: Product) => void;
    onCancel: () => void;
}

export function AdminProductView({product, inventory, onStore, onCancel}: AdminProductViewProps) {
    const {t} = useLocalization();
    const handleStoreClick = useCallback(() => onStore(product), [onStore, product]);
    return (
        <View>
            <VendingViewHeader title={product.name} onBack={onCancel}/>
            <ViewContent className={classNames(layout.vertical, layout.center, layout.alignCenter)}>
                <div className={classNames(layout.horizontal)}>
                    <div className={classNames(theme.moreContrast, layout.vertical, styles.boxLeft)}>
                        <div className={styles.imageContainer}>
                            <img src={product.image} alt={product.name} className={styles.image} />
                        </div>
                    </div>
                    <div className={classNames(theme.lessContrast, layout.vertical, layout.spaceBetween, styles.boxRight)}>
                        <div className={styles.name}>
                            {product.name}
                        </div>
                        <div className={styles.description}>
                            {product.description}
                        </div>
                        <div className={styles.description}>
                            € {product.price.gross.toFixed(2)}
                        </div>
                        <div className={styles.description}>
                            {inventory.getCount(product)} mal verfügbar
                        </div>
                        <div>
                            <PushButton primary className={classNames(styles.button, styles.marginBottom)}
                                        onClick={handleStoreClick}>
                                {t("Store")}
                            </PushButton>
                        </div>
                    </div>
                </div>
                <div>
                </div>
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    boxLeft: {
        width: "24em"
    },
    boxRight: {
        width: "20em",
        padding: "1.5em"
    },
    button: {
        width: "100%"
    },
    marginBottom: {
        marginBottom: "0.5rem"
    },
    name: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "1.25em",
    },
    description: {
        flexGrow: 1,
        paddingTop: "1.5em",
        paddingBottom: "1.5em",
    },
    imageContainer: {
        height: "22em",
        margin: "0 auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1em"
    },
    image: {
        height: "100%",
        maxHeight: "100%",
        width: "auto"
    },
});
